export default __webpack_public_path__ + "static/media/Ideate_1.ee1287e1.jpg";